import React from 'react';
import { formStyles } from '../utils/formStyles';
import { useTranslation } from 'react-i18next';

export function AwardFormFields({ formData, handleChange, handleSubmit, isEdit = false, onCancel }) {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="name" className={`${formStyles.label} ${formData.name ? formStyles.labelActive : ''}`}>
          {t('awardform.name')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="date"
          id="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="date" className={`${formStyles.label} ${formData.date ? formStyles.labelActive : ''}`}>
          {t('awardform.date')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="text"
          id="location"
          name="location"
          value={formData.location}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="location" className={`${formStyles.label} ${formData.location ? formStyles.labelActive : ''}`}>
          {t('awardform.location')}
        </label>
      </div>
      
      <div className="flex justify-end gap-4">
        <button type="submit" className={formStyles.button}>
          {isEdit ? t('awardform.update') : t('awardform.create')}
        </button>
        {isEdit && onCancel && (
          <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 dark:bg-zinc-700 rounded text-gray-800 dark:text-gray-200">
            {t('awardform.cancel')}
          </button>
        )}
      </div>
    </form>
  );
}